module.exports = __webpack_public_path__ + "img/Jon.68a7331d.png";